import { render } from "./ClubPicture.vue?vue&type=template&id=12208da8&scoped=true"
import script from "./ClubPicture.vue?vue&type=script&lang=js"
export * from "./ClubPicture.vue?vue&type=script&lang=js"

import "./ClubPicture.vue?vue&type=style&index=0&id=12208da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12208da8"]])

export default __exports__